import React, { Component } from "react";
import PropTypes from "prop-types";
// import bannerOne from "../../assets/hotel.JPG";
import { Link } from "react-router-dom";
export default class about extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  render() {
    return (
      <div>
        <section className="about" id="about">
          <div className="container">
            <div className="content">
              <div className="fcont">
                <div className="fitem">
                  <div className="img-cont">
                    <span></span>
                    <h3>Cozy Room</h3>
                    <p>
                      Far far away, behind the word mountains, far from the
                      countries Vokalia.
                    </p>
                  </div>
                  <img src="assets/ex.jpeg" alt="" />
                </div>
                <div className="litem">
                  <img src="assets/hotel.JPG" alt="" />
                  <div className="img-cont">
                    <span></span>
                    <h3>Special Offers</h3>
                    <p>
                      Far far away, behind the word mountains, far from the
                      countries Vokalia.
                    </p>
                  </div>
                </div>
              </div>
              <div className="lcont">
                <h6>ABOUT HOTEL PALASH RESIDENCY</h6>
                <h1>Welcome to our Hotel</h1>
                <p>
                  Feel like Home , Business from Home .Located at the centre of
                  Ranchi's Business It's in the center of the Ranchi Business
                  district.Opposite to the 1 of the biggest malls in Ranchi and
                  located conviniently near to the Ranchi Railway Station and
                  Bus Stand.
                </p>
                <Link href="">More info</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
